exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper-block-ui {\n  border: none;\n  border-radius: 5px;\n  height: 100%;\n  position: relative;\n  width: 100%;\n  padding: 0 1em 1em;\n  box-shadow: 1px 1px 10px 1px lightgray; }\n  .wrapper-block-ui .wrapper-block-ui-header {\n    border: none;\n    border-radius: 5px 5px 0 0;\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    padding: 0.3em 1em;\n    background: #007eca;\n    color: white; }\n  .wrapper-block-ui .wrapper-block-ui-body {\n    border: none;\n    padding: 2.5em 0 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/components/block/block-ui.style.scss
// module id = ../../../../../src/app/components/block/block-ui.style.scss
// module chunks = main